import { IconX } from '@tabler/icons-react';
import { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import { uploadFile } from '../../../../api/api.global';

const CreateCannedReplyModal = ({ buttonComponent, callback }) => {
    const [show, setShow] = useState(false);
    const [selectedTags, setSelectedTags] = useState([])

    const [inputValue, setInputValue] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [cursorPos, setCursorPos] = useState(0);
    const inputRef = useRef(null);
    const [selectedMediaType, setSelectedMediaType] = useState(null);
    const [file, setFile] = useState(null);

    const handleClose = () => { setSelectedTags([]); setInputValue(""); setShowSuggestions(false); setSelectedMediaType(null); setFile(null); setShow(false) };
    const handleShow = () => setShow(true);

    const add = async () => {

        let localData = {
            message: document.getElementById("message")?.value?.trim(),
            tags: selectedTags
        }
        let postData = {
            message: localData.message,
            messageType: (selectedMediaType) || 1
        }

        if (localData?.tags?.length > 0) {
            postData.tags = localData.tags
        }

        if ((selectedMediaType == 2) && file) {
            postData.file = await uploadFile(file, 'advy-canned-reply-file')
        }

        if ((selectedMediaType == 3) && file) {
            postData.voice = await uploadFile(file, 'advy-canned-reply-voice-file')
        }

        loadingShow();
        let resp = await postApi(postData, urlApi?.createCannedReply);
        loadingHide();
        if (resp.responseCode == 200) {
            toast.success(resp?.message);
            callback?.();
            handleClose();
        } else {
            toast.error(resp?.message);
        }
    }

    const availableKeys = [
        "user.visitorName",
        "user.chatSessionCount",
        "user.lastMessage",
        "user.status",
        "user.visitorOnlineStatus"
    ];

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setCursorPos(e.target.selectionStart);

        // Show suggestions if `{{` is typed
        if (value.slice(e.target.selectionStart - 2, e.target.selectionStart) === "{{") {
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelect = (key) => {
        const before = inputValue.slice(0, cursorPos);
        const after = inputValue.slice(cursorPos);
        const newValue = `${before}${key}}}${after}`; // already typed `{{`
        setInputValue(newValue);
        setShowSuggestions(false);

        // Restore cursor to after inserted text
        setTimeout(() => {
            const newCursor = before.length + key.length + 2;
            inputRef.current.setSelectionRange(newCursor, newCursor);
        }, 0);
    };

    const tags = ['Acknowledgement', 'Apologies', 'Feedback', 'Forward', 'Greetings', 'Internal Transfer', 'Issue Fixed', 'Issue Reported', 'Reminder', 'Request', 'Response', 'Thank You', 'New Visitor', 'Pricing enquiry', 'Repeated Visitor'];

    const handleTagClick = (tag) => {
        if (selectedTags.includes(tag)) {
            setSelectedTags(selectedTags.filter(item => item !== tag));
        } else {
            setSelectedTags([...selectedTags, tag]);
        }
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <div>
                            <p className="text-md font-semibold mb-0">Add Canned Reply Message</p>
                            <div className="text-xs italic text-gray-600">*You can add maximum of 20 canned replies.</div>
                        </div>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div>
                        <div className='mb-3'>
                            <label htmlFor="name" className='text-sm font-semibold mb-1'>Message</label>
                            <p className='mb-2 text-sm italic text-[var(--secondary)]'>For dynamic variable use '&#123;&#123;' to get suggestion ( ex. &#123;&#123;user.visitorName&#125;&#125; )</p>
                            <textarea ref={inputRef} type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" id='message' rows={5} value={inputValue}
                                onChange={handleChange}
                                placeholder="Type something with {{ to get suggestions..."></textarea>
                        </div>

                        {showSuggestions && (
                            <ul className="absolute bg-white border rounded shadow p-2 mt-1 z-10 w-full max-h-48 overflow-y-auto">
                                {availableKeys.map((key) => (
                                    <li
                                        key={key}
                                        className="cursor-pointer hover:bg-gray-200 px-2 py-1"
                                        onClick={() => handleSelect(key)}
                                    >
                                        {key}
                                    </li>
                                ))}
                            </ul>
                        )}

                        <div className="mb-3">
                            <label htmlFor="">Tags</label>
                            <div className='flex flex-wrap gap-2 mt-1'>
                                {
                                    tags?.map((item, index) => {
                                        return (
                                            <button key={index} onClick={() => handleTagClick(item)} className={`${selectedTags.includes(item) ? 'bg-primary text-white' : 'bg-gray-100'} text-gray-600 rounded-md px-2 py-1 text-xs`}>{item}</button>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className="mb-6">
                            <label htmlFor="media-list-type" className="block text-sm font-medium text-gray-700 mb-1">
                                Add Media
                            </label>
                            <select
                                id="media-list-type"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                                onChange={(e) => setSelectedMediaType(e.target.value)}
                            >
                                <option value={null}>None</option>
                                <option value={2}>Image/File</option>
                                <option value={3}>Audio</option>
                            </select>

                            {selectedMediaType && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Upload File
                                    </label>
                                    <input
                                        type="file"
                                        accept={
                                            selectedMediaType == 2
                                                ? "*"
                                                : selectedMediaType == 3
                                                    ? "audio/*"
                                                    : "*"
                                        }
                                        onChange={(e) => setFile(e.target.files[0])}
                                        className="block w-full text-sm text-gray-700 border border-gray-300 rounded-md cursor-pointer focus:outline-none"
                                    />
                                </div>
                            )}

                            {selectedMediaType == 2 && file && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Preview</label>
                                    <img
                                        src={URL.createObjectURL(file)}
                                        alt="Sorry Preview not available for this file type."
                                        className="w-32 h-32 object-cover rounded-md border"
                                    />
                                </div>
                            )}

                            {selectedMediaType == 3 && file && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Preview</label>
                                    <audio controls src={URL.createObjectURL(file)} className="w-full rounded-md" />
                                </div>
                            )}

                            {selectedMediaType == 2 && file && (
                                <div className="mt-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">File Name</label>
                                    <p className="text-sm text-gray-800">{file?.name}</p>
                                </div>
                            )}
                        </div>


                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateCannedReplyModal